import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=3ef4732e&scoped=true&"
import script from "./PageContainer.vue?vue&type=script&lang=js&"
export * from "./PageContainer.vue?vue&type=script&lang=js&"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=3ef4732e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef4732e",
  null
  
)

export default component.exports